module.exports = __webpack_public_path__ + "static/media/iqra5.c903d4e8.jpg";